import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../features/project-on-board/redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import { ErrorMessage, Field, Formik, Form } from 'formik';
import CustomSelect from '../../common/formElements/CustomSelect';
import CustomLoader from '../common/CustomLoader';
import { drapcodeIcon } from '../../common/custom/icon-library';
import ParentContentCard from '../common/ParentContentCard';

export class XanoTableData extends Component {
  static propTypes = {
    projectOnBoard: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    selectedCollectionId: 0,
    resultColl: {},
    fieldDatatypes: [],
    apitabledata: {},
    upid: null,

  };

  async componentDidMount() {
    const { dbUuid, projectId, version } = this.props.match.params;
    const { location, actions } = this.props
    await actions.apicallGetTbalesData({ projectId, dbUuid, version });
    const { completeData, uuid } = this.props.projectOnBoard.apigetTableData;
    this.setState({ apitabledata: completeData });
    this.setState({ upid: uuid });
    const { tables } = completeData ? completeData : [];
    if (location.state.collectionid) {
      this.setState({ selectedCollectionId: location.state.collectionid })
      this.handleCollection(this.state.selectedCollectionId);
    } else {

      if (tables && tables.length > 0) {
        const firstCollectionId = tables[0].id;
        this.handleCollection(firstCollectionId);
      }

    }

  }

  handleCollection = async (idcol) => {
    const { completeData } = this.props.projectOnBoard.apigetTableData;
    const { workspace, tables } = completeData;
    const { token } = this.props.location.state;
    await this.props.actions.xanocollectionNames({ token, workspaceId: workspace.id, idcol });
  };

  handleFieldChange = (fieldName, selectedValue) => {
    const updatedResult = { ...this.state.fieldDatatypes };
    updatedResult[fieldName[0].name] = selectedValue;
    this.setState({ fieldDatatypes: updatedResult });
  };

  handleFormSubmit = async () => {
    const { workspace, tables } = this.state.apitabledata;
    const { fieldDatatypes } = this.state;
    const { upid } = this.state;
    const newArray = this.props.projectOnBoard.xanoCollectionNameData.filter((element, index) => {
      if (index !== 0 && index !== 1) {
        return element;
      }
    });
    const result = {};
    newArray.forEach((item) => {
      const fieldValue = fieldDatatypes[item.name] || (item.type === 'int' ? 'number' : item.type);
      result[item.name] = fieldValue;
    });

    let idx = tables.findIndex((item) => item.id === this.state.selectedCollectionId);
    const collectionName = idx === -1 ? tables[0].name : tables[idx].name;
    const objectIdToUpdate = idx === -1 ? tables[0].id : tables[idx].id;

    const newresult = {};
    for (const key in result) {
      if (result.hasOwnProperty(key)) {
        newresult[key] = result[key] === 'int' ? 'number' : result[key];
      }
    }
    const { projectId, dbUuid } = this.props.match.params;
    const savefieldsobj = {
      fieldsToUpdate: newresult,
      objectIdToUpdate,
    };

    await this.props.actions.apicallToAddFields({ savefieldsobj, projectId, upid });
    const data = {
      collectionTitle: collectionName,
      willPersist: false,
      fields: newresult,
      projectId,
      externalDatabaseId: dbUuid,
      tableId: objectIdToUpdate,
      workspaceId: workspace.id,
      setting: {
        developer_key: this.props.location.state.token,
      },
    };
    const savecoll = await this.props.actions.createCollectionWithXano(data);
    this.setState({ resultColl: savecoll });

    if (this.props.location.state.collectionid) {
      this.props.history.push(`/2.0/data-connector/${projectId}/external-database-edit/${upid}`);

    } else {

      if (tables.length - 1 == idx) {
        this.props.history.push(`/2.0/collections/${projectId}`);
      }

    }

  };

  handleSkip = () => {
    const { upid } = this.state;
    const { projectId } = this.props.match.params;
    let currentIndex = this.state.apitabledata.tables.findIndex(
      (item) => item.id === this.state.selectedCollectionId,
    );
    if (currentIndex < 0) {
      currentIndex = 0;
    }
    const nextIndex = currentIndex + 1;
    if (nextIndex < this.state.apitabledata.tables.length) {
      const nextCollectionId = this.state.apitabledata.tables[nextIndex].id;
      this.handleCollection(nextCollectionId);
      this.setState({ selectedCollectionId: nextCollectionId });
    }

    if (this.props.location.state.collectionid) {
      this.props.history.push(`/2.0/data-connector/${projectId}/external-database-edit/${upid}`);

    } else {

      if (this.state.apitabledata.tables.length - 1 == currentIndex) {
        this.props.history.push(`/2.0/collections/${projectId}`);
      }

    }

  };
  handleSaveAndContinue = async () => {
    await this.handleFormSubmit();
    const { tables } = this.state.apitabledata;
    let currentIndex = tables.findIndex((item) => item.id === this.state.selectedCollectionId);
    if (currentIndex < 0) {
      currentIndex = 0;
    }
    const nextIndex = currentIndex + 1;
    if (nextIndex < tables.length) {
      const nextCollectionId = tables[nextIndex].id;
      if (this.state.resultColl.data) {
        await this.handleCollection(nextCollectionId);
        this.setState({ selectedCollectionId: nextCollectionId });
      }
    }
  };

  render() {
    console.log("xanotable console", this.props)
    const { apitabledata, selectedCollectionId, fieldDatatypes } = this.state;
    const { tables } = apitabledata;
    const { projectOnBoard } = this.props;
    const { xanoCollectionNameData, apicallGetTbalesDataPending } = projectOnBoard;
    if (this.state.apitabledata.tables) {
      var curidx = this.state.apitabledata.tables.findIndex(
        (item) => item.id === selectedCollectionId,
      );
      var colname = curidx === -1 ? tables[0].name : tables[curidx].name;
    }

    if (xanoCollectionNameData.length == 0 && this.state.apitabledata) {
      return (
        <CommonPageComponent>
          <div className="text-center">
            <CustomLoader loading={apicallGetTbalesDataPending} size="20px" color="#303453" />
          </div>
        </CommonPageComponent>
      );
    }
    return this.state.apitabledata ? (
      <CommonPageComponent>
        <ParentContentCard
          title="Choose This Collection for Create Or Skip via Xano"
          icon="collection"
        >
          <Formik initialValues={{}}>
            {({ values, handleChange, setFieldValue }) => (
              <Form className="form-row">
                <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
                  <div className="form-row justify-content-center">
                    <div className="col-sm-3">
                      <label>
                        <b>Collection Name :</b>
                      </label>
                    </div>
                    <div className="col-sm-3">
                      <label>
                        <b>{colname}</b>
                      </label>
                    </div>
                  </div>
                  <div className="form-row mb-3 mt-3 justify-content-center">
                    <div className="col-sm-3">
                      <b>Fields</b>
                    </div>
                    <div className="col-sm-3">
                      <b>Field Types</b>
                    </div>
                  </div>
                  {xanoCollectionNameData.map((header, index) =>
                    header.name === 'id' || header.name === 'created_at' ? null : (
                      <div key={index} className="form-row justify-content-center">
                        <div className="col-sm-3">
                          <label htmlFor={index}>{header.name}</label>
                        </div>
                        <div className="col-sm-3">
                          <CustomSelect
                            name={header}
                            isMulti={false}
                            onChange={setFieldValue}
                            onChangeValue={this.handleFieldChange}
                            options={[
                              { label: 'String', value: 'text' },
                              { label: 'Number', value: 'int' },
                              { label: 'Boolean', value: 'boolean' },
                              { label: 'Password', value: 'password' },
                              { label: 'Email', value: 'email' },
                            ]}
                            value={this.state.fieldDatatypes[header.name] || header.type}
                          />
                        </div>
                      </div>
                    ),
                  )}
                  <div className="d-flex justify-content-around align-items-center mt-3">
                    <button
                      className="btn btn-outline-secondary btn-md"
                      title="Skip"
                      type="button"
                      onClick={this.handleSkip}
                    >
                      <i className="wb webconnect-times"></i> Skip & Continue
                    </button>
                    <button
                      type="button"
                      className="btn btn-theme-submit btn-md ml-3"
                      title="Save Collection"
                      onClick={this.handleSaveAndContinue}
                    >
                      <i className="wb webconnect-save-regular"></i> Save & Continue
                      <CustomLoader loading={apicallGetTbalesDataPending} />
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </ParentContentCard>
      </CommonPageComponent>
    ) : null;
  }
}

function mapStateToProps(state) {
  return {
    projectOnBoard: state.projectOnBoard,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(XanoTableData);
